module.exports = __webpack_public_path__ + "img/badge_teatro_mostre.8eec8874.jpg";